<main class="ai-search-page">
  <section class="ai-search-header">
    <div>
      <div class="page-heading">
        <div class="page-title">AI Search Lab</div>
        <div class="page-subtitle">
          Ask plain-English questions across DeepRoots inquiries, then combine
          the answer with practical filters a loan officer already uses.
        </div>
      </div>
    </div>
    <div>
      <span class="eyebrow">Experimental</span>
    </div>
  </section>

  <section class="ai-search-shell">
    <aside class="filters-panel">
      <div class="panel-heading">
        <h2>Filters</h2>
        <button type="button" (click)="clearFilters()">Clear</button>
      </div>

      <label>
        State
        <select [formControl]="searchForm.controls.state">
          <option value="">Any state</option>
          @for (state of states; track state) {
            <option [value]="state">{{ state }}</option>
          }
        </select>
      </label>

      <div class="field-group">
        <span>Loan amount</span>
        <div class="amount-grid">
          <input
            type="number"
            min="0"
            placeholder="Min"
            [formControl]="searchForm.controls.loanAmountMin"
          />
          <input
            type="number"
            min="0"
            placeholder="Max"
            [formControl]="searchForm.controls.loanAmountMax"
          />
        </div>
      </div>

      <label>
        Business stage
        <select [formControl]="searchForm.controls.hasBusiness">
          <option value="">Any stage</option>
          <option value="yes">Existing business</option>
          <option value="planning">Planning stage</option>
        </select>
      </label>

      <label>
        Solar interest
        <select [formControl]="searchForm.controls.interestedInSolar">
          <option value="">Any</option>
          <option value="true">Interested in solar</option>
          <option value="false">Not marked interested</option>
        </select>
      </label>

      <div class="field-group">
        <span>Products</span>
        <div class="product-list">
          @for (product of productOptions; track product.value) {
            <label class="check-row">
              <input
                type="checkbox"
                [checked]="selectedProducts.has(product.value)"
                (change)="toggleProduct(product.value)"
              />
              {{ product.label }}
            </label>
          }
        </div>
      </div>
    </aside>

    <section class="search-workspace">
      <form class="query-panel" [formGroup]="searchForm" (ngSubmit)="search()">
        <div class="query-row">
          <label class="query-field">
            Search question
            <textarea
              rows="3"
              formControlName="query"
              placeholder="Find businesses looking for solar financing and technical assistance"
            ></textarea>
          </label>
          <div class="query-controls">
            <label>
              Results
              <input type="number" min="1" max="50" formControlName="top" />
            </label>
          </div>
        </div>

        <div class="examples-row">
          @for (example of examples; track example.label) {
            <button type="button" (click)="applyExample(example)">
              {{ example.label }}
            </button>
          }
        </div>

        <button class="search-button" type="submit" [disabled]="loading">
          {{ loading ? "Searching..." : "Search inquiries" }}
        </button>
      </form>

      @if (errorMessage) {
        <div class="error-message">{{ errorMessage }}</div>
      }

      <div class="results-summary">
        @if (response) {
          <span
            >{{ response.count | number }} matches from Azure AI Search</span
          >
        } @else {
          <span>Run a query to see ranked matches.</span>
        }
      </div>

      <div class="results-list">
        @for (result of response?.results || []; track result.document.id) {
          <article
            class="result-card"
            (click)="viewRecordDetails(result.document.id)"
            (keydown.enter)="viewRecordDetails(result.document.id)"
            tabindex="0"
          >
            <div class="result-main">
              <div class="result-heading">
                <h2>
                  {{ result.document.business_name || "Unnamed business" }}
                </h2>
                <span class="score"
                  >Score {{ result.score | number: "1.2-2" }}</span
                >
              </div>
              <p class="applicant">
                {{ result.document.applicant_name || "Unknown applicant" }}
                @if (getLocation(result)) {
                  <span>• {{ getLocation(result) }}</span>
                }
              </p>
              <p class="snippet">{{ getSnippet(result) }}</p>
              <div class="tag-row">
                @for (
                  product of result.document.interested_products || [];
                  track product
                ) {
                  <span>{{ product }}</span>
                }
              </div>
            </div>
            <aside class="result-metrics">
              <div>
                <span>Loan amount</span>
                <strong>
                  {{
                    result.document.loan_amount === null ||
                    result.document.loan_amount === undefined
                      ? "Not listed"
                      : (result.document.loan_amount
                        | currency: "USD" : "symbol" : "1.0-0")
                  }}
                </strong>
              </div>
              <div>
                <span>Credit</span>
                <strong>{{
                  result.document.credit_score_range || "N/A"
                }}</strong>
              </div>
              <div>
                <span>Stage</span>
                <strong>{{ result.document.has_business || "N/A" }}</strong>
              </div>
            </aside>
          </article>
        } @empty {
          @if (response && !loading) {
            <div class="empty-state">
              No matches found. Try loosening filters or switching to hybrid
              mode.
            </div>
          }
        }
      </div>
    </section>
  </section>
</main>

@if (showRecordDetails) {
  <app-record-details
    [unique_id]="uniqueId"
    (popupClosed)="showRecordDetails = false"
  ></app-record-details>
}
